import './App.css';
import React, { useRef, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import StoreSettingsPage from './pages/StoreSettingsPage';
import OffersPage from './pages/OffersPage';
import MessagesPage from './pages/MessagesPage';
import ItemsPage from './pages/ItemsPage';
import AddItemPage from './pages/AddItemPage';
import MyAccountPage from './pages/MyAccountPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ViewOfferPage from './pages/ViewOfferPage';
import ViewItemPage from './pages/ViewItemPage';
import EditItemPage from './pages/EditItemPage';
import CustomersPage from './pages/CustomersPage';
import ViewCustomerPage from './pages/ViewCustomerPage';
import NotFoundPage from './pages/NotFoundPage';

import AuthLayout from './layouts/AuthLayout';
import DefaultLayout from './layouts/DefaultLayout';
import NotFoundLayout from './layouts/NotFoundLayout';

import RequireAuthRoute from './components/RequireAuthRoute';
import { AppProvider } from './context/AppContext';
import { ReferenceDataProvider } from './context/ReferenceDataContext';
import { ApiProvider, useApiContext } from './context/ApiContext';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SignUpPage from './pages/SignUpPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ApiInterceptorInitializer from './components/ApiInterceptorInitializer';
import BillingPage from './pages/BillingPage';



export interface ScrollableRefProps {
  scrollContainerRef: React.RefObject<HTMLDivElement>;
}

function App() {
  const scrollContainerRef = useRef<HTMLDivElement>(null!);

  const router = createBrowserRouter([
    {
      element: <AuthLayout />,
      children: [
        { path: '/forgotPassword', element: <ForgotPasswordPage /> },
        { path: '/resetPassword/:token', element: <ResetPasswordPage /> },
        { path: '/verifyEmail/:token', element: <VerifyEmailPage /> }
      ]
    },
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      path: '/signup',  // standalone route
      element: <SignUpPage />
    },
    {
      element: <RequireAuthRoute><DefaultLayout scrollContainerRef={scrollContainerRef} /></RequireAuthRoute>,
      children: [
        { path: '/', element: <HomePage /> },
        { path: '/storeSettings', element: <StoreSettingsPage /> },
        { path: '/offers', element: <OffersPage /> },
        { path: '/offers/view/:offerId?', element: <ViewOfferPage /> },
        { path: '/customers', element: <CustomersPage /> },
        { path: '/customers/view/:customerId?', element: <ViewCustomerPage /> },
        { path: '/messages/:threadId?', element: <MessagesPage /> },
        { path: '/items', element: <ItemsPage scrollContainerRef={scrollContainerRef} /> },
        { path: '/items/add', element: <AddItemPage /> },
        { path: '/items/view/:itemId?', element: <ViewItemPage scrollContainerRef={scrollContainerRef} /> },
        { path: '/items/edit/:itemId?', element: <EditItemPage /> },
        { path: '/billing', element: <BillingPage /> },
        { path: '/myAccount', element: <MyAccountPage /> },
        { path: '/changePassword', element: <ChangePasswordPage /> },

      ]
    },
    {
      element: <NotFoundLayout />,
      children: [
        { path: '*', element: <NotFoundPage /> }
      ]
    }
  ]);

  return (
    <AppProvider>
      <ReferenceDataProvider>
        <RouterProvider router={router}>
          <ApiProvider>
            {null}
          </ApiProvider>
        </RouterProvider>
      </ReferenceDataProvider>
    </AppProvider>
  );
}

export default App;